<template>
  <v-flex mb-0 xs12 mx-2>
    <v-layout row justify-start mx-3 mt-3 align-center>
      <div class="text-xs-left" style="font-sze: 20px; font-weight: 600;">Toll Free Service Info</div>
    </v-layout>

    <v-form v-model="valid" @submit="editTollFreeService" ref="editTollFreeServiceForm">
      <v-layout grid-list-md justify-start pa-0 ma-0 mr-0 pr-0 mt-2>
        <v-layout hide-details justify-start row mt-0 mb-2>
          <!-- Left Column of Fields -->
          <v-flex hide-details mx-4 xs4>
            <v-text-field
              style="max-height: 45px"
              v-model="service.TFN"
              value="TFN"
              label="Toll Free #*"
              mask="(###) ###-####"
              required
              :rules="identifierRules"
            ></v-text-field>
            <v-text-field
              style="max-height: 45px"
              v-model="service.RTN"
              value="RTN"
              label="Ring-to Telephone #*"
              mask="(###) ###-####"
              :rules="rtnRules"
            ></v-text-field>
            <v-autocomplete
              hide-details
              :items="ddlTollFreeClass"
              v-model="service.TollFreeClass"
              item-text="Text"
              item-value="Value"
              label="Toll Free Class*"
              required
              :rules="requiredRules"
            ></v-autocomplete>
            <v-text-field
              style="max-height: 45px"
              v-model="service.CurrentRespOrgId"
              label="Current Resp. Org. ID"
              maxlength = "10"
            ></v-text-field>
          </v-flex>
          <!-- Center Column of Fields -->
          <v-flex hide-details mx-4 xs4>
            <v-autocomplete
              hide-details
              :items="ddlInvoiceDetail"
              v-model="service.InvoiceDetail"
              item-text="Text"
              item-value="Value"
              label="Invoice Detail*"
              clearable
              required
              :rules="requiredRules"
            ></v-autocomplete>
            <v-autocomplete
              hide-details
              :items="ddlInterRate"
              v-model="service.InterRate"
              item-text="Text"
              item-value="Value"
              label="Inter Rate*"
              clearable
              required
              :rules="requiredRules"
            ></v-autocomplete>
            <v-autocomplete
              hide-details
              :items="ddlIntraRate"
              v-model="service.IntraRate"
              item-text="Text"
              item-value="Value"
              label="Intra Rate*"
              clearable
              required
              :rules="requiredRules"
            ></v-autocomplete>
            <v-autocomplete
              hide-details
              :items="ddlIntlRate"
              v-model="service.IntlRate"
              item-text="Text"
              item-value="Value"
              label="Intl Rate*"
              clearable
              required
              :rules="requiredRules"
            ></v-autocomplete>
          </v-flex>
          <!-- Right Column of Fields -->
          <v-flex hide-details mx-4 xs4>
            <v-text-field
              style="max-height: 45px"
              v-model="service.BillPrintText"
              value="BillPrintText"
              label="Bill Print Text"
              maxlength="25"
            ></v-text-field>
            <v-text-field
              style="max-height: 45px"
              v-model="service.OrderNumber"
              label="Order #*"
              required
              maxlength="20"
              :rules="requiredRules"
            ></v-text-field>
            <v-menu
              v-model="menu"
              :close-on-content-click="true"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <v-text-field
                style="max-height: 44px"
                slot="activator"
                v-model="service.OrderDate"
                label="Order Date*"
                prepend-inner-icon="fa-calendar-alt"
                readonly
                clearable
                required
                :rules="requiredRules"
              ></v-text-field>
              <v-date-picker v-model="service.OrderDate" @input="menu = false"></v-date-picker>
            </v-menu>
            <v-text-field
              style="max-height: 45px"
              v-model="service.LOA"
              value="OrderNumber"
              label="Letter Of Agency #"
              required
              maxlength="20"
            ></v-text-field>
            <v-menu
              v-model="menu1"
              :close-on-content-click="true"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <v-text-field
                style="max-height: 44px"
                slot="activator"
                v-model="service.LOADate"
                label="Letter Of Agency Date"
                prepend-inner-icon="fa-calendar-alt"
                readonly
                clearable
                required
              ></v-text-field>
              <v-date-picker v-model="service.LOADate" @input="menu1 = false"></v-date-picker>
            </v-menu>
           
            <v-autocomplete
              hide-details
              :items="ddlSalesIds"
              v-model="service.SalesId"
              value="SalesId"
              label="Sales ID*"
              required
              :rules="requiredRules"
              item-text="Text"
              item-value="Value"
            ></v-autocomplete>
             <v-autocomplete
              style="margin-top: 10px;"
              hide-details
              :items="ddlActionRequest"
              v-model="service.ActionRequest"
              item-text="Text"
              item-value="Value"
              clearable
              required
              :rules="requiredRules"
            >
              <template slot="label">
                <div class="red--text">Service Action*</div>
              </template>
            </v-autocomplete>
          </v-flex>
        </v-layout>
      </v-layout>
      <v-layout row hide-details justify-start ml-4 mt-0 mb-0>
        <v-checkbox
          label="Use Service Point Address?"
          v-model="showSPAddress"
        ></v-checkbox>
      </v-layout>
      <v-layout row hide-details justify-start mt-0 mb-4 v-if="showSPAddress">
        <servicePointAddress v-if="showSPAddress" ref="componentSPAddress" :ServicePointAddress="service.ServicePointAddress ? service.ServicePointAddress : {}"></servicePointAddress>
      </v-layout>
      <v-layout hide-details justify-end row mt-0 mb-4>
        <v-btn color="success" @click="editTollFreeService()" class="ml-2 mr-4">Edit</v-btn>
      </v-layout>
    </v-form>
  </v-flex>
</template>

<script>
import axios from "axios";
import Bus from "../../bus";
import servicePointAddress from "./ServicePointAddress.vue";


export default {
  name: "EditTollFreeService",
  props: [
    "accountNumber",
    "elementType",
    "elementDescription",
    "serviceType",
    "providerId",
    "serviceId"
  ],
  components: {
    servicePointAddress
  },
  async mounted() {
    // Populate Invoice Detail DDL
    axios
      .get("/api/Services/GetInvoiceDetailLevelDDLs/"+this.serviceType)
      .then(response => {
        this.ddlInvoiceDetail = response.data;
        if (this.ddlInvoiceDetail.length === 1) {
          this.service.InvoiceDetail = this.ddlInvoiceDetail[0].Value;
        }
      })
      .catch(error => {
        console.log(error);
      });
    // Populate Inter Rate DDL
    axios
      .get("/api/Services/GetRatePlansDDL/"+this.serviceType+"/IE")
      .then(response => {
        this.ddlInterRate = response.data;
      })
      .catch(error => {
        console.log(error);
      });
    // Populate Intra Rate DDL
    axios
      .get("/api/Services/GetRatePlansDDL/"+this.serviceType+"/IA")
      .then(response => {
        this.ddlIntraRate = response.data;
      })
      .catch(error => {
        console.log(error);
      });
    // Populate Intl Rate DDL
    axios
      .get("/api/Services/GetRatePlansDDL/"+this.serviceType+"/IT")
      .then(response => {
        this.ddlIntlRate = response.data;
      })
      .catch(error => {
        console.log(error);
      });
    // Populate Sales Ids DDL
    axios
      .get("/api/Services/GetSalesIdDDL")
      .then(response => {
        this.ddlSalesIds = response.data;
        if (this.ddlSalesIds.length === 1) {
          this.service.SalesId = this.ddlSalesIds[0].Value;
        }
      })
      .catch(error => {
        console.log(error);
      });
      // Populate Toll Free Class DDL
    await axios
      .get("/api/Services/GetTollFreeClassDDL/"+this.providerId)
      .then(response => {
        this.ddlTollFreeClass = response.data;
      })
      .catch(error => {
        console.log(error);
      });
      var GetEditServiceInfo = await axios
      .get("api/Services/GetEditServiceInfo/" + this.serviceId)
      .then(async res =>{
        this.service = await res.data;
        this.ddlActionRequest = await res.data.ddlActionRequest;
        if (this.service.OrderDate) {
          this.service.OrderDate = this.service.OrderDate.split("T")[0];
        }
        if (this.service.LOADate) {
          this.service.LOADate = this.service.LOADate.split("T")[0];
        }
        
        if (this.service.InvoiceDetail) {
          this.service.InvoiceDetail = this.service.InvoiceDetail.toString()
        }
       
        this.service.ActionRequest = "ZZ";
      });
      if (this.service.ServicePointAddress){
          this.showSPAddress = true
        }
  },

  data() {
    return {
      service: {},
      valid: true,
      menu: false,
      menu1:false,
      showSPAddress: false,

      // Drop down list variables
      ddlInvoiceDetail: [],
      ddlSalesIds: [],
      ddlInterRate: [],
      ddlIntraRate: [],
      ddlIntlRate: [],
      ddlTollFreeClass:[],
      ddlActionRequest:[],

      // Form validation Rules
      identifierRules: [
        v => !!v || "",
        v =>
          /^[1-9][0-9]{9}$/.test(v) || "Toll Free # must be 10 digits",
          v=> /^(\+?1)?(8(00|11|22|33|44|55|66|77|88)\d{7})$/.test(v) || "Toll Free # must have repeating 2nd and 3rd digits"
      ],
      rtnRules: [
        v => !!v || "",
        v =>
          /^[1-9][0-9]{9}$/.test(v) || "Ring-to Telephone # must be 10 digits"
      ],
      requiredRules: [v => !!v || ""]
    };
  },

  methods: {
    async editTollFreeService() {
      if (this.$refs.editTollFreeServiceForm.validate()) { 
        if (this.showSPAddress) {
          this.service.ServicePointAddress = await this.$refs.componentSPAddress
            .servicePointAddress;
        }else{
          if (this.service.ServicePointAddress){
            delete this.service.ServicePointAddress
          }
        }
        axios
          .post("/api/Services/EditTollFreeService", this.service)
          .then(res => {
            console.log(res);
            Bus.$emit("alert", {
              color: "success",
              message: "Service Edited Successfully!"
            });
            this.$emit("close");
          })
          .catch(err => {
            console.log(err);

            Bus.$emit("alert", {
              color: "error",
              message: "An Error Occured while Creating Service."
            });
          });
      }
    }
  }
};
</script>